import { restClient, restClientGeneral } from "libs/restClient";
import { requestStatuses } from "helpers/RequestHelper";
import * as actions from "actions/types";
import * as call from "helpers/ActionHelper";
import { notifyMessages } from "helpers/NotifyHelper";

const fetchModelVersions = id => async dispatch => {
  try {
    const url = `/requests?where=devicemodelid=${id} AND requeststatusid!=${requestStatuses.requestWithdrawn}&orderBy=transactionnumber DESC`;
    const payload = restClient.get(url);

    dispatch({
      type: actions.FETCH_MODEL_VERSIONS,
      payload
    });

    return payload;
  } catch (e) {
    dispatch(call.showNotice(notifyMessages.errorFetchRequestAction));

    return Promise.reject(e);
  }
};

const get__modelCertifiedVersions = id => async dispatch => {
  try {
    const url = `/requests?&orderBy=transactionnumber DESC&where=devicemodelid=${id} AND requeststatusid=${requestStatuses.approved}`;
    const payload = await restClient.get(url);

    dispatch({
      type: actions.FETCH_MODEL_VERSIONS,
      payload
    });

    return payload;
  } catch (e) {
    dispatch(call.showNotice(notifyMessages.errorFetchRequestAction));

    return Promise.reject(e);
  }
};

export const fetchModelCertifiedVersions = id => async dispatch => {
  dispatch(call.startPreloader());
  dispatch(get__modelCertifiedVersions(id))
    .then(() => dispatch(call.stopPreloader()))
    .catch(() => dispatch(call.stopPreloader()));
};

export const fetchModel = id => async dispatch => {
  try {
    const url = `/devicemodels/${id}?include=devicemodelbands,vendor`;
    const payload = await restClient.get(url);

    dispatch({
      type: actions.FETCH_MODEL,
      payload
    });

    return payload;
  } catch (e) {
    dispatch(call.showNotice(notifyMessages.errorFetchRequestAction));

    return Promise.reject(e);
  }
};

export const fetchModelAndVersions = modelId => async dispatch => {
  dispatch(call.startPreloader());
  dispatch(clearModel());
  dispatch(fetchModel(modelId))
    .then(() => dispatch(fetchModelVersions(modelId)))
    .then(() => dispatch(call.stopPreloader()))
    .catch(() => dispatch(call.stopPreloader()));
};

export function updateModel(event) {
  const { id, name, value } = event.target;
  const field = id || name;

  return {
    type: actions.UPDATE_MODEL,
    payload: { [field]: value }
  };
}

export function clearModel() {
  return {
    type: actions.CLEAR_MODEL,
    payload: null
  };
}

export const checkFccId = fccId => async dispatch => {
  try {
    const payload = await restClientGeneral.get(`/fcc/${fccId}`);

    dispatch({
      type: actions.CHECK_FCC_ID,
      payload
    });

    return payload;
  } catch (e) {
    dispatch(call.showNotice(notifyMessages.errorFetchRequestAction));

    return Promise.reject(e);
  }
};

export const checkExistedModel = modelName => async dispatch => {
  try {
    const url = `/devicemodels?include=requests&where=modelnumber='${modelName}' AND requesttypeid=1 AND requeststatusid <> ${requestStatuses.requestWithdrawn}`;
    const payload = await restClient.get(url);

    dispatch({
      type: actions.CHECK_EXISTED_MODEL,
      payload
    });

    return payload;
  } catch (e) {
    dispatch(call.showNotice(notifyMessages.errorFetchRequestAction));

    return Promise.reject(e);
  }
};



// WEBPACK FOOTER //
// ./src/actions/model.js